import React from 'react'
import { Row, Col } from 'antd'

const permissionsStartImg = require('@src/images/permissions-start.svg')
const permissionsFinishImg = require('@src/images/permissions-finish.svg')

function PermissionsTopImage(props: any) {
  const imgUrl = props.showControls ? permissionsFinishImg : permissionsStartImg

  return (
    <>
      <Row>
        <Col className="text-center">
          <img src={imgUrl} className="img-fluid" />
        </Col>
      </Row>
      <hr className="divider" />
    </>
  )
}

export default PermissionsTopImage